import './Grid.css'

const Grid = ({x, y1, y2, tickCount}) => {
    const ticks = x.ticks(tickCount)

    return ticks.map(value => [value, x(value)]).map(([value, position]) => (
        <line
            className={"gridLine"}
            id={position}
            key={`grid-${position}`}
            y1={y1}
            y2={y2}
            x1={position}
            x2={position}
            stroke="black"
            strokeWidth={1}
            strokeDasharray={"4 4"}
        />
    ))

}

export default Grid;
